(() => {
  function initialize(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const swatches = [...root.querySelectorAll('[data-shade-button]')];
    const families = [...root.querySelectorAll('[data-color-family]')];
    const stock = root.querySelector('[data-color-stock]');
    const detail = root.querySelector('#av-color-detail');
    const form = root.querySelector('[data-color-form]');
    const initialCount = root.querySelector('[data-color-count]').textContent;
    let family = 'all';
    let selected;
    const setText = (selector, value) => { root.querySelector(selector).textContent = value; };
    function select(button) {
      selected = button;
      const data = button.dataset;
      swatches.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      setText('[data-color-title]', data.name);
      setText('[data-color-code]', data.code);
      setText('[data-color-family-name]', data.familyName);
      setText('[data-color-description]', data.description);
      setText('[data-color-price]', data.variant ? data.price : '');
      const image = root.querySelector('[data-color-image]');
      image.src = data.image;
      image.alt = data.code + ' ' + data.name;
      root.querySelector('[data-color-variant]').value = data.variant;
      const available = data.available === 'true' && Boolean(data.variant);
      const add = root.querySelector('[data-color-add]');
      add.disabled = !available;
      add.hidden = !available;
      const help = root.querySelector('[data-color-help]');
      help.hidden = available;
      help.href = 'https://wa.me/60193005300?text=' + encodeURIComponent('Hello, I would like to ask about Cloud Soft Matte Lip Mousse ' + data.code + ' ' + data.name + '.');
      root.querySelector('[data-color-link]').href = data.url;
      detail.hidden = false;
    }
    function filter() {
      const visible = swatches.filter(button => (family === 'all' || button.dataset.family === family) && (!stock.checked || button.dataset.available === 'true'));
      swatches.forEach(button => { button.closest('[data-shade-item]').hidden = !visible.includes(button); });
      families.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.colorFamily === family)));
      root.querySelector('[data-color-count]').textContent = initialCount.replace('27', String(visible.length));
      root.querySelector('[data-color-empty]').hidden = visible.length > 0;
      if (!visible.length) detail.hidden = true;
      else if (!visible.includes(selected)) select(visible.find(button => button.dataset.available === 'true') || visible[0]);
    }
    swatches.forEach(button => button.addEventListener('click', () => select(button)));
    families.forEach(button => button.addEventListener('click', () => { family = button.dataset.colorFamily; filter(); }));
    stock.addEventListener('change', filter);
    let adding = false;
    let feedbackTimer;
    function dismissFeedback(feedback) {
      feedbackTimer = setTimeout(() => {
        if (feedback.matches(':hover, :focus-within')) dismissFeedback(feedback);
        else feedback.hidden = true;
      }, 6000);
    }
    root.addEventListener('submit', async event => {
      const submitted = event.target;
      if (!submitted.matches('.av-color-quick-form, [data-color-form]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (adding) return;
      if (submitted === form && (!selected || selected.dataset.available !== 'true')) return;
      const payload = new FormData(submitted);
      if (!payload.get('id')) return;
      const feedback = root.querySelector('[data-color-feedback]');
      const message = root.querySelector('[data-color-message]');
      const buttons = [...root.querySelectorAll('button[type="submit"]')];
      const previous = buttons.map(button => button.disabled);
      const trigger = submitted.querySelector('button[type="submit"]');
      const label = trigger.textContent;
      const shadeName = submitted.closest('[data-shade-item]')?.querySelector('[data-shade-button]').dataset.name || selected?.dataset.name || '';
      clearTimeout(feedbackTimer);
      adding = true;
      buttons.forEach(button => { button.disabled = true; });
      trigger.textContent = root.dataset.adding;
      feedback.hidden = false;
      message.textContent = root.dataset.adding;
      let confirmed = false;
      try {
        const endpoint = new URL(submitted.action, location.origin);
        endpoint.pathname = endpoint.pathname.replace(/\/add\/?$/, '/add.js');
        const response = await fetch(endpoint.href, { method: 'POST', body: payload, credentials: 'same-origin', headers: { Accept: 'application/json' } });
        const result = await response.json().catch(() => null);
        if (!response.ok) {
          message.textContent = typeof result?.description === 'string' ? result.description : root.dataset.addError;
          return;
        }
        const addedItem = result?.items?.find(item => String(item.variant_id || item.id) === String(payload.get('id'))) || result;
        if (!addedItem || String(addedItem.variant_id || addedItem.id) !== String(payload.get('id'))) throw new Error('Cart response did not confirm the selected shade');
        confirmed = true;
        message.textContent = shadeName + ' · ' + root.dataset.added;
        dismissFeedback(feedback);
        const cartResponse = await fetch(root.dataset.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store' });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('[data-avh-count]').forEach(badge => { badge.textContent = cart.item_count; });
        }
      } catch (error) {
        if (!confirmed) {
          message.textContent = root.dataset.addUncertain;
          console.error('[AVENYS Cosmetics] Add request failed:', error.name, error.message);
        }
      } finally {
        buttons.forEach((button, index) => { button.disabled = previous[index]; });
        root.querySelector('[data-color-add]').disabled = !selected || selected.dataset.available !== 'true';
        trigger.textContent = label;
        adding = false;
      }
    }, true);
    filter();
  }
  const boot = () => document.querySelectorAll('[data-color-studio]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();



